import { render, staticRenderFns } from "./EscenarioDetail.vue?vue&type=template&id=f2c21266&scoped=true&"
import script from "./EscenarioDetail.vue?vue&type=script&lang=js&"
export * from "./EscenarioDetail.vue?vue&type=script&lang=js&"
import style0 from "./EscenarioDetail.vue?vue&type=style&index=0&id=f2c21266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c21266",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VContainer,VDataTable,VIcon,VLayout,VTextField,VToolbar,VToolbarTitle})
